import { render, staticRenderFns } from "./fileblock.vue?vue&type=template&id=36f29ed7&"
import script from "./fileblock.vue?vue&type=script&lang=js&"
export * from "./fileblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports